// Helpers for capturing and reading the referral code from the URL/localStorage.
const REF_KEY = "gpv_ref_code";

export function captureRefFromUrl() {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (ref && /^[A-Z0-9-]{4,32}$/i.test(ref)) {
    try {
      localStorage.setItem(REF_KEY, ref.toUpperCase());
    } catch {}
  }
}

export function getStoredRef(): string | null {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(REF_KEY);
  } catch {
    return null;
  }
}

export function clearStoredRef() {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(REF_KEY);
  } catch {}
}
